import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { ValidationService } from '../validation.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-bulk-upload-vehicle',
  templateUrl: './bulk-upload-vehicle.component.html',
  styleUrls: ['./bulk-upload-vehicle.component.scss']
})
export class BulkUploadVehicleComponent implements OnInit {
  fileChoosen: any;
  heading: any = 'Upload File';
  fileHeading: any = 'Upload File';
  downloadURL: any = '';
  urlType = 0;

  @ViewChild('fileInput', {static: false}) InputVar: ElementRef;

// this InputVar is a reference to our input.


  constructor(private dialog: MatDialogRef<BulkUploadVehicleComponent>,  @Inject(MAT_DIALOG_DATA) private parentData: any,
              private snackbar: SnackbarService, private http: HttpService, private valid: ValidationService,
              private translation: TranslateService) { }

  ngOnInit() {
    (this.parentData.heading) ? this.heading = this.parentData.heading : '';
    (this.parentData.fileHeading) ? this.fileHeading = this.parentData.fileHeading : '';
    this.downloadURL = (this.parentData.sampleURL) ? this.parentData.sampleURL : '';
  }

  fileChanged(event) {
    this.fileChoosen = event.target.files;
  }

  upload() {
    if (!this.fileChoosen) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.BULK_UPLOAD.VALID.FILE'), '', 'err');
      return false;
    }
    let formData: any = new FormData();

    if (this.parentData.uploadURL == 'driver/bulk_upload') {
      formData.append('drivers', this.fileChoosen[0], this.fileChoosen[0].name);
    } else if (this.parentData.uploadURL == 'vehicle/bulk_upload') {
      this.urlType = 3;
      formData.append('vehicles', this.fileChoosen[0], this.fileChoosen[0].name);
    }

    this.http.upload(this.parentData.uploadURL, formData,this.urlType).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          if (this.parentData.uploadURL == 'driver/bulk_upload') {
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.BULK_UPLOAD.SUCCESS.UPLOAD_DRIVER'), '');
          } else if (this.parentData.uploadURL == 'vehicle/bulk_upload') {
            this.snackbar.openSnackBar(this.translation.instant('MESSAGE.BULK_UPLOAD.SUCCESS.UPLOAD_VEHICLE'), '');
          }
          this.dialog.close(data);
        }
      },
      (err: any) => {
        formData = new FormData();
        this.InputVar.nativeElement.value = "";
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  closeDialog() {
    this.dialog.close();
  }

}
